import { application, every } from './_common';

export default [
  ...every,
  ...application,
  {
    order: 3,
    icon: 'mdi-account-supervisor',
    text: 'Мои пользователи',
    to: '/users',
  },
];
